import { render, staticRenderFns } from "./Pentathlon.vue?vue&type=template&id=6fc7de11&scoped=true"
import script from "./Pentathlon.vue?vue&type=script&lang=js"
export * from "./Pentathlon.vue?vue&type=script&lang=js"
import style0 from "./Pentathlon.vue?vue&type=style&index=0&id=6fc7de11&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc7de11",
  null
  
)

export default component.exports